<template>
  <div class="content">
    <UpdatePassword />
    <UpdateProfile />
  </div>
</template>
<script>
import UpdatePassword from './UpdatePassword.vue';
import UpdateProfile from './UpdateProfile.vue';

export default {
  components: {
    UpdatePassword,
    UpdateProfile,
  },
  data() {
    return {
      form: {
        fullName: this.$store.state.userData.name || '',
        email: this.$store.state.userData.email || '',
        phoneNumber: this.$store.state.userData.phone || '',
      },
      snackBar: {
        show: false,
        message: null,
      },
    };
  },
  methods: {
    async updateProfile() {
      try {
        if (!this.form.fullName || !this.form.email || !this.form.phoneNumber) {
          this.snackBar = {
            show: true,
            message: 'Please enter all fields before proceeding',
          };
          return;
        }
        this.$store.commit('busyStatus', true);
        // const { message } = await http.authReq(
        //   "/dashboard/password/update",
        //   {
        //     ...this.form,
        //   },
        //   "post"
        // );

        this.$store.commit('busyStatus', false);
        this.snackBar = {
          show: true,
          // message,
          message: 'Success',
        };
      } catch (error) {
        this.$store.commit('busyStatus', false);
        this.snackBar = {
          show: true,
          message: error.response ? error.response.data.message : error.message,
        };
      }
    },
  },
};
</script>

<style scoped>
.md-card-header {
  background: transparent !important;
  font-weight: 500;
}
.card {
  padding-top: 2em;
}
</style>
